import type { IconSvgObject } from './types';

const CircleArrowDataTransferDiagonalIcon: IconSvgObject = [
  ["path", { d: "M8 10.5V13.5L13.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 13.5V10.5L10.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CircleArrowDataTransferDiagonalIcon;
